import { Pipe, PipeTransform } from '@angular/core';
import { human_phone, is_phone_number_a_mobile, validate_phone_number } from '../tools/phone-number';

@Pipe({name: 'phone'})
export class phonePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return human_phone(value);
  }
}

@Pipe({name: 'isphone'})
export class isPhonePipe implements PipeTransform {
  transform(value: string | null | undefined): boolean {
    return validate_phone_number(value);
  }
}

@Pipe({name: 'ismobile'})
export class isMobilePipe implements PipeTransform {
  transform(value: string | null | undefined): boolean {
    return is_phone_number_a_mobile(value);
  }
}